
import { Component } from '@angular/core';

@Component({
  selector: 'app-select-campaign-page',
  templateUrl: './select-campaign.page.html'
})
export class SelectCampaignPage {
  constructor( ) {
  }
}
